import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";
import TirPlanView from "../components/TirPlanView";
import { BrandMark } from "../components/Brand";

export default function PublicTirPlan() {
  const { token } = useParams();
  const [plan, setPlan] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/public/tir-plan/${token}`, { silent: true }).then((r) => setPlan(r.data)).catch(() => setErr("PLAN BULUNAMADI")); }, [token]);
  return (
    <div data-testid="public-tir-plan" className="min-h-screen bg-slate-950 p-3 text-slate-100">
      <div data-testid="public-brand" className="mb-2 flex items-center gap-3">
        {plan?.brand?.name && <BrandMark brand={plan.brand} size={40} />}
        <div className="text-sm font-bold text-amber-300">{plan?.brand?.name ? (plan.brand.hide_mw ? plan.brand.name : `${plan.brand.name} · MWCRMPRO`) : "MWCRMPRO"} · ŞOFÖR YÜKLEME PLANI</div>
      </div>
      {err && <div className="py-20 text-center text-slate-400">{err}</div>}
      {plan && <TirPlanView plan={plan} readOnly onReload={() => {}} />}
    </div>
  );
}
